import { UpdatePageMeta, UpdatePagePayload } from 'types/store/UpdatePageState';
import { createAsyncReducer } from 'utils/Redux';

import { updatePageActions } from '../actions';

export default createAsyncReducer<UpdatePageMeta, UpdatePagePayload>(
  updatePageActions
);
